export const maxPostCharacters = 999;
